"use client";

import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Elena Rossi",
  quote: "The transition from the final Savasana into the first course was seamless. A truly magnetic experience that stayed with me for weeks.",
  position: "Creative Director",
  initials: "ER"
}, {
  author: "Marcus Chen",
  quote: "High-vibration energy meets culinary mastery. Yoga Dinners isn't just an event; it's a sacred ritual for the modern soul.",
  position: "Sound Architect",
  initials: "MC"
}];
export default function VoicesOfThePool() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}